import { Constants } from 'src/constants';
import { LabelColor } from 'src/components/label/types';
import { SavedTrip, Trip } from './types';

export const tripStatusText = (status: number) => {
  if (status === Constants.TRIP_STATUS_NEW) {
    return 'New';
  }
  if (status === Constants.TRIP_STATUS_STARTED) {
    return 'Started';
  }
  if (status === Constants.TRIP_STATUS_FINISHED) {
    return 'Finished';
  }
  if (status === Constants.TRIP_STATUS_ABANDONED) {
    return 'Abandoned';
  }
  return 'Unknown';
};

export const tripStatusColor = (status: number): LabelColor => {
  if (status === Constants.TRIP_STATUS_NEW) {
    return 'info';
  }
  if (status === Constants.TRIP_STATUS_STARTED) {
    return 'success';
  }
  if (status === Constants.TRIP_STATUS_ABANDONED) {
    return 'error';
  }
  return 'default';
};

export const latenessColor = (lateHours: number | null): LabelColor => {
  if (lateHours === null) {
    return 'default';
  }
  if (lateHours <= 0) {
    return 'success';
  }
  if (lateHours < 1) {
    return 'warning';
  }
  return 'error';
};

export const latenessText = (lateHours: number | null) => {
  if (lateHours === null) {
    return '—';
  }
  if (lateHours <= 0) {
    return 'On time';
  }
  if (lateHours < 1) {
    return `${Math.round(lateHours * 60)}m behind`;
  }
  return `${lateHours.toFixed(1)}h late`;
};

// adapts a persisted trip into the Plan page's saved-file shape so the existing
// hydration path (driver + stops + auto-replan) can load it unchanged
export const toSavedTrip = (trip: Trip, driverName: string): SavedTrip => ({
  version: 1,
  savedAt: trip.createdAt,
  eldDriverId: trip.eldDriverId,
  driverName,
  origin: { address: trip.originAddress, lat: trip.originLat, lng: trip.originLng },
  tripDepartAt: trip.plannedDepartAt,
  plannedDepartAt: trip.plannedDepartAt,
  stops: trip.stops.map((stop) => ({
    label: stop.label,
    address: stop.address,
    lat: stop.lat,
    lng: stop.lng,
    appointmentAt: stop.appointmentAt,
    dwellHours: stop.dwellHours,
    departAt: stop.departAt,
    plannedArrival: stop.plannedArrival,
    plannedDeparture: stop.plannedDeparture,
    done: stop.done,
  })),
});
